import { JSONSchema7 } from 'json-schema';
import { FormValidation, UiSchema } from '@rjsf/core';
import { DataJSON } from '../services/DataService';

export interface GeneralContractorJSON extends DataJSON {
  id?: string;
  name?: string;
  licenseNumber?: string;
  phoneNumber?: string;
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  state?: string;
  zip?: string;
  contactName?: string;
  email?: string;
}

export const GeneralContractorJSONSchema: JSONSchema7 = {
  $comment: 'General Contractor',
  type: 'object',
  required: [ 'name', 'addressLine1', 'city', 'state', 'zip', 'phoneNumber', 'contactName' ],
  properties: {
    name: {
      type: 'string',
      title: 'GC\'s Company Name',
    },
    contactName: {
      type: 'string',
      title: 'Contact Person',
    },
    email: {
      type: 'string',
      title: 'Email Address',
      format: 'email',
    },
    licenseNumber: {
      type: 'string',
      title: 'License Number',
    },
    phoneNumber: {
      type: 'string',
      title: 'Phone Number',
      pattern: '^\\(?([0-9]{3})\\)?[-.●]?([0-9]{3})[-.●]?([0-9]{4})$',
    },
    addressLine1: {
      type: 'string',
      title: 'Address Line 1',
    },
    addressLine2: {
      type: 'string',
      title: 'Address Line 2',
    },
    city: {
      type: 'string',
      title: 'City',
    },
    state: {
      type: 'string',
      title: 'State',
      enum: [ 'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY' ]
    },
    zip: {
      type: 'string',
      title: 'Zip',
    },
  },
};

export const GeneralContractorUISchema: UiSchema = {
};

export const validateGeneralContractor = (formData: GeneralContractorJSON, errors: FormValidation): FormValidation => {
  // Do some cool custom validation in here
  // If there is an error you can use errors.addError()
  return errors;
};
